import AddressBook from "Components/address/AddressSelection"
import React, { useMemo, useState } from "react"
import { useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { processCollaborationMilestoneStep } from "services/api/collaboration"
import { SavedAddress } from "types"
import { Milestone, MilestoneStep } from "types/collaboration"
import inModal from "utils/hoc/inModal"

interface AddressSelectionProps {
    activeMilestone: Milestone,
    isActive: boolean,
    onClose: (refetch?: boolean) => void,
    step: MilestoneStep
}
const AddressSelection: React.FC<AddressSelectionProps> = ({ onClose, step }) => {

    const { campaignId, milestoneId, collaborationId } = useParams();
    const [submitting, setSubmitting] = useState(false);

    const [selectedAddress, setSelectedAddress] = useState<SavedAddress | null>(null);

    const submitAddress = async () => {
        if (!campaignId || submitting || !selectedAddress || !collaborationId || !milestoneId) return;
        try {
            setSubmitting(true);
            await processCollaborationMilestoneStep(campaignId, collaborationId, milestoneId, { step: step.gig_step.slug, 'address': selectedAddress.uuid });
            onClose(true);
        } catch (error:any) {
            console.log(error);
            toast.error(error?.response?.data?.message ?? "Unknown error occurred.")
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <>
            <AddressBook
                onSelection={(address) => setSelectedAddress(address)}
            />
            <div className="milestone-step-actions px-3 pb-5">
                <button className="theme-btn theme-btn-primary-outlined" onClick={() => onClose()}>Cancel</button>
                <button className="theme-btn theme-btn-primary" disabled={!selectedAddress || submitting} onClick={submitAddress}>Submit</button>
            </div>
        </>
    )
}


const AddressSelectionModal: React.FC<AddressSelectionProps> = (props) => {
    const title = `Select Address`

    const ModalComponent = useMemo(() => inModal(AddressSelection, title), [title])
    return <ModalComponent {...props} />
}


export default AddressSelectionModal;